module.exports = __webpack_public_path__ + "static/7-be0dc693db89d731c6983c55f2cf2aa2.jpg";